import { type FC } from 'react';
import { Form } from 'react-bootstrap';
import cx from 'clsx';

import { type Figure, FigureType } from '@editor2/types/pageElements';
import { updateElement } from '@editor2/reducers/editor/editorSlice';
import { figureElement } from './styles';
import { figureToFigureProperties } from '@editor2/mappers/element';
import CopyInput from '@editor2/components/CopyInputWrapper';
import BigQuoteEpigraphForm from './BigQuoteEpigraphForm';
import FigureCommonForm from './FigureCommonForm';
import { useDebouncedDispatch } from '@editor2/hooks/useDebouncedDispatch';
import { useDebounceProtectedState } from '@editor2/hooks/useDebounceProtectedState';
import { elementCommonStyles } from '@editor2/styles/element';

interface Props {
	element: Figure;
	courseId: number;
}

const FigureElement: FC<Props> = (props) => {
	const { element, courseId } = props;

	const commonPayload = { elementId: element.family_id, courseId };
	const debouncedDispatch = useDebouncedDispatch();

	const [figureProperties, handleLocalChange] = useDebounceProtectedState(
		element,
		figureToFigureProperties
	);

	const handleChange = (value) => {
		handleLocalChange(value);
		debouncedDispatch(updateElement({ ...commonPayload, ...value }));
	};

	return (
		<Form className={cx(figureElement, elementCommonStyles)}>
			<CopyInput label="Family ID" value={element.family_id} />

			<Form.Group>
				<Form.Label>Type</Form.Label>
				<Form.Control
					as="select"
					className="select"
					value={figureProperties.figure_type}
					onChange={(e) => handleChange({ figure_type: e.target.value })}>
					{Object.keys(FigureType).map((type) => (
						<option key={type} value={type}>
							{type}
						</option>
					))}
				</Form.Control>
			</Form.Group>

			{element.figure_type === FigureType.big_quote_epigraph ? (
				<BigQuoteEpigraphForm figureProperties={figureProperties} onChange={handleChange} />
			) : (
				<FigureCommonForm figureProperties={figureProperties} onChange={handleChange} />
			)}
		</Form>
	);
};

export default FigureElement;
